import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import * as yup from "yup";
import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import apiErrorsToFormik from "utils/api-errors-to-formik";

import { Routes } from "../../constants/routes";
import { useActionHook, useDidUpdate } from "../../hooks";
import { useUserActions } from "../../store";

import "./ChangePassword.styles.scss";

const passInitValues = {
  current_password: "",
  password: "",
  confirmation: ""
};

const passValidation = yup.object().shape({
  current_password: yup.string(),
  password: yup.string().required("Password is required").min(8),
  confirmation: yup
    .string()
    .required("Confirmation is required")
    .oneOf([yup.ref("password"), null], "password doesn't match")
});

export const ChangePassword: React.FC = () => {
  const { changeUserPasswordAction } = useUserActions();
  const { push } = useHistory();

  const { error: changePassErrors, action: changePass } = useActionHook(changeUserPasswordAction, {
    onSuccess: () => {
      toast("The password has been changed successfully");
      push(Routes.profile);
    }
  });

  const { handleSubmit, values, errors, isValid, setErrors, handleChange } = useFormik({
    initialValues: passInitValues,
    validationSchema: passValidation,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: async (values) =>
      await changePass({
        current_password: values.current_password,
        password: values.password,
        password_confirmation: values.confirmation
      })
  });

  useDidUpdate(() => {
    if (changePassErrors?.errors) {
      setErrors(apiErrorsToFormik(passInitValues, changePassErrors.errors));
    }
  }, [changePassErrors]);

  return (
    <main className="change-pass__content">
      <form className="change-pass__form" onSubmit={handleSubmit}>
        <span className="change-pass__title">Change Password</span>
        <TextField
          label="Enter a Current Password"
          placeholder="Current password"
          name="current_password"
          sx={{ width: 300 }}
          value={values.current_password}
          onChange={handleChange}
          error={!!errors.current_password}
          helperText={errors.current_password}
          type="password"
        />
        <TextField
          label="Enter a New Password"
          placeholder="New password"
          name="password"
          sx={{ width: 300 }}
          value={values.password}
          onChange={handleChange}
          error={!!errors.password}
          helperText={errors.password}
          type="password"
        />
        <TextField
          label="Confirm a New Password"
          placeholder="Confirm new password"
          name="confirmation"
          sx={{ width: 300 }}
          value={values.confirmation}
          onChange={handleChange}
          error={!!errors.confirmation}
          helperText={errors.confirmation}
          type="password"
        />
        <Button
          variant="contained"
          sx={{
            borderRadius: "5px",
            textTransform: "none",
            width: 300,
            height: 45,
            color: "#26A6AE"
          }}
          type="submit"
          disabled={!isValid}
        >
          Change Password
        </Button>
      </form>
    </main>
  );
};
